import { ReactNode } from 'react';
import { getModalTabConfigs } from 'pages/accountDrawer/modalTabConfig';
import type { LinkedinTabLabel } from 'pages/accountDrawer/linkedinView/index';
import { DrawerTab } from './types';

interface TaskSplitHeader {
  label: ReactNode;
  icon: ReactNode;
}

// Reuses modalTabConfig so the split header can't drift from the tab pill.
export function getTaskSplitHeader(
  tab: DrawerTab | null | undefined,
  linkedinTabLabel: LinkedinTabLabel,
): TaskSplitHeader | null {
  if (!tab) return null;

  const configs = getModalTabConfigs(linkedinTabLabel);
  if (!(tab in configs)) return null;

  const { label, renderIcon } = configs[tab as keyof typeof configs];
  return { label, icon: renderIcon(true) };
}
